import { getToken } from "firebase/messaging";
import { messaging, VAPID_KEY } from "./firebase";

/**
 * Request FCM token for push notifications.
 * Best called from a user gesture (e.g. Login click) so permission works in incognito/private windows.
 */
export const requestFCMToken = async () => {
    try {
        if (!("Notification" in window) || !("serviceWorker" in navigator)) {
            return null;
        }

        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("Notification permission denied");
            return null;
        }

        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        await registration.ready;

        const fcmToken = await getToken(messaging, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration,
        });

        if (fcmToken) {
            try {
                localStorage.setItem("device_token", fcmToken);
            } catch {
                // Ignore in private/incognito if localStorage is restricted
            }
        }

        return fcmToken;
    } catch (error) {
        console.error("Error requesting FCM token:", error);
        return null;
    }
};

export default requestFCMToken;
